// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

window.Gradient2TestScreen = ( function()
{
    "use strict";

    Gradient2TestScreen.prototype = new Screen();

    function Gradient2TestScreen(){}

    Gradient2TestScreen.prototype.init = function()
    {
        var angle, delta;
        var alphas, colors;
        var alpha2, color2;
        var linear, radial;
        var params, gradient;

        var i;
        var x, y;
        var col, row;
        var w = 4/3 * 200, h = 200;

        Screen.prototype.init.call( this );
        this._className = "Gradient2TestScreen";

        //this._bg = new RectWidget().init( { w:_x2._config._screenW, h:_x2._config._screenH, color:"#000000" } );
        //this.addWidget( this._bg );
        this.addWidget( new ImageWidget().init( { url: _x2._config._imageRoot + "welcomeBg.jpg" } ) );

        this._grads = [];

        alphas =
        [
            {
                opacity : 100,
                location:   0
            },
            {
                opacity :  50,
                location: 100
            }
        ];

        colors =
        [
            {
                color   : "#FF0000",
                location: 0
            },
            {
                color   : "#0000FF",
                location: 100
            }
        ];

        // reverse only alphas/colors, keep locations
        alpha2 = JSON.parse(JSON.stringify(alphas)).reverse(); // deep copy [] & {}
        alpha2[0].location = 0;
        alpha2[1].location = 85;

        color2 = JSON.parse(JSON.stringify(colors)).reverse(); // deep copy [] & {}
        color2[0].location = 0; // colors[0].location;
        color2[1].location = 85; // colors[1].location;

        linear =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Linear,
            angle: 0,
            alphas: alphas,
            colors: colors
        };

        radial =
        {
            w: w,
            h: h,
            type: GradientWidget.Type.Radial,
            alphas: alpha2,
            colors: color2
        };

        x = Style._safeLeft;
        y = Style._safeTop;

        angle = 0;
        delta = 45;

        for( i = 0; i < 9; i++ )
        {
            col = i % 3;
            row =(i / 3) | 0;

            if( col === 0 )
            {
                switch( row )
                {
                    case 0: angle = 135; delta = -45; break;
                    case 1: angle = 180; delta =  90; break;
                    case 2: angle = 225; delta = +45; break;
                }
            }

            if( i !== 4 )
            {
                params = Object.assign( {}, linear );
                params.angle = angle;
            }
            else
            {
                params = Object.assign( {}, radial );
            }

            gradient = new GradientWidget().init( params );

            this._grads.push( gradient );
            this.addWidget( gradient, x, y );

//console.log( "(" + i + ") %o", params );

            x += w;
            angle += delta;

            if( col === 2)
            {
                x = Style._safeLeft;
                y += h;
            }
        }

        this._selectable = true;

        return this;
    };

    return Gradient2TestScreen;

})();
